import RasterModel from "./raster";
import RasterRgbModel from "./rasterRgb";
import RasterTerrainRGB from "./rasterTerrainRgb";
var RasterModels = {
  raster: RasterModel,
  rasterRgb: RasterRgbModel,
  raster3d: RasterModel,
  rasterTerrainRgb: RasterTerrainRGB
};
export default RasterModels;